import Axios from 'axios';
import Vue from 'vue';
import i18n from '../../../i18n';
import { API_HOST } from '../../../config/app-const';
import { normalize } from '../../../helpers/pagination';

const state = {
  isBusy: false,
  data: [],
  pagination: null,
  error: null,
  updating: false,
};

const mutations = {
  LOAD_USER_PERMISSIONS_BUSY: (state, payload) => {
    state.isBusy = payload;
  },
  LOAD_USER_PERMISSIONS_SUCCESS: (state, {data, pagination}) => {
    if (pagination && pagination.currentPage === 1) state.data = []
    data.forEach(item => state.data.push(item));
    state.pagination = pagination;
    state.error = null;
  },
  LOAD_USER_PERMISSIONS_FAIL: (state, payload) => {
    state.data = null;
    state.error = payload;
  },

  UPDATE_USER_PERMISSIONS_BUSY: (state, payload) => {
    state.updating = payload;
  },
  UPDATE_USER_PERMISSIONS_SUCCESS: (state, payload) => {
    state.data = state.data.map(row => row.user_id == payload.user_id ? Object.assign({}, row, payload) : row);
    state.error = null;
  },
  UPDATE_USER_PERMISSIONS_FAIL: (state, payload) => {
    state.data = null;
    state.error = payload;
  },
}

const actions = {
  getUserPermissions: ({ commit, state, rootState }, { pagination, filters }) => {
    if (state.isBusy == false) {
      commit('LOAD_USER_PERMISSIONS_BUSY', true);

      const { accessToken } = rootState.user.user.data;
      const config = {
        headers: { Authorization: `Token token=${accessToken}` }
      };

      let query = '?';
      const normalizedPagination = normalize(pagination);
      Object.keys(normalizedPagination).map((param, i) => {
        query += `${param}=${normalizedPagination[param]}${i !== Object.keys(normalizedPagination).length - 1 ? '&' : ''}`;
      });

      const normalizedFilters = normalize(filters || {});
      if (Object.keys(normalizedFilters).length > 0) {
        query += "&";
        Object.keys(normalizedFilters).map((param, i) => {
          query += `${param}=${normalizedFilters[param]}${i !== Object.keys(normalizedFilters).length - 1 ? '&' : ''}`;
        });
      }   

      return Axios
        .get(`${API_HOST}/analysis/userinfo/permissions${query}`, config)
        .then(response => {
          let permissions = {
            data : response.data.data.data.permissions,
            pagination : response.data.data.pagination
          };
          commit('LOAD_USER_PERMISSIONS_SUCCESS', permissions)
        })
        .catch(error => {
          Vue.notify({
            group: 'store_notifications',
            type: 'error',
            text: i18n.t('messages.request.error')
          });

          console.error(error);
          commit('LOAD_USER_PERMISSIONS_FAIL', error)
        })
        .finally(() => commit('LOAD_USER_PERMISSIONS_BUSY', false));
    }
  },

  updateUserPermissions: ({ commit, state, rootState }, { row }) => {

    if (state.updating == true) {
      return;
    }

    commit('UPDATE_USER_PERMISSIONS_BUSY', true);

    const { id, accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    const body = row;

    return Axios
      .put(`${API_HOST}/analysis/userinfo/permissions/${row.user_id}/upsert`, body, config)
      .then(response => {
        commit('UPDATE_USER_PERMISSIONS_SUCCESS', response.data)
      })
      .catch(error => {
        Vue.notify({
          group: 'store_notifications',
          type: 'error',
          text: i18n.t('messages.request.error')
        });

        console.error(error);
        commit('UPDATE_USER_PERMISSIONS_FAIL', error)
      })
      .finally(() => commit('UPDATE_USER_PERMISSIONS_BUSY', false));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};